export enum DashboardKeys {
	ChaneelAnalytics = 'chaneel.analytics',
	OverallAnalytics = 'overall.analytics',
	OverallAnalyticsCumulative = 'overall.analytics.cumulative',
	OverallAnalyticsAggregate = 'overall.analytics.aggregate',
	WithDrawDepositGraph = 'withdraw.deposit.graph',
	PlayerDepositWithdrawGraph = 'player.deposit.withdraw.graph',
	TransactionSummary = 'transaction.summary',
	ChannelTransactionCumulative = 'channel.transaction.cumulative',
	ChannelPlayers = 'channel.players',
	ChannelCohortAnalytics = 'channel.cohort.analytics',
	PromotionAnalytics = 'promotion.analytics',
	PromotionDetail = 'promotion.detail',
	PlayLogs = 'play.logs',
	GameProviders = 'game.providers',
	GetOnlineActiveUser = 'user.onlineActive',
	LineAnalytics = 'line.analytics',
	ActiveUsers = 'active.users',
	ActiveUsersSummary = 'active.users.summary',
	PlayerGameStats = 'player.game.stats',
}
